"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const computeArrayReuseMap_1 = __importDefault(require("./computeArrayReuseMap"));
const getType_1 = __importDefault(require("./getType"));
const isDeepEqual_1 = __importDefault(require("./isDeepEqual"));
const path_1 = require("./path");
function diff(_old, _new, opts = {}) {
    var _a;
    const patches = [];
    const createOp = opts.enableCreateOp ? 'create' : 'set';
    const isAtomic = typeof opts.isAtomic === 'function' ? opts.isAtomic : null;
    const queue = [{ a: _old, b: _new, path: opts.basePath || '' }];
    while (queue.length) {
        const qItem = queue.pop();
        const { a, b, path } = qItem;
        if (Object.is(a, b))
            continue;
        const aType = (0, getType_1.default)(a);
        const bType = (0, getType_1.default)(b);
        if (!aType || aType !== bType) {
            // 类型不同 OR 非 object / array
            patches.push({ op: 'set', path, value: b });
            continue;
        }
        // 接下来 aType === bType 并且非空
        if (isAtomic && isAtomic(path, a, b)) {
            // 这个 key 不需要深入 diff，就整个对象的深层 isDeepEqual 一下看看就行
            if (!(0, isDeepEqual_1.default)(a, b)) {
                patches.push({ op: 'set', path, value: b });
            }
            continue;
        }
        if (aType === 'object') {
            const oldKeys = new Set(Object.keys(a));
            Object.keys(b).forEach((key) => {
                if (oldKeys.has(key)) {
                    // existing.
                    oldKeys.delete(key);
                    const na = a[key];
                    const nb = b[key];
                    if (Object.is(na, nb))
                        return;
                    queue.push({ a: na, b: nb, path: (0, path_1.pushPath)(path, key) });
                }
                else {
                    // new key
                    patches.push({
                        path: (0, path_1.pushPath)(path, key),
                        op: createOp,
                        value: b[key],
                    });
                }
            });
            oldKeys.forEach((key) => {
                patches.push({ path: (0, path_1.pushPath)(path, key), op: 'delete' });
            });
        }
        if (aType === 'array') {
            const indexMap = (0, computeArrayReuseMap_1.default)(a, b, (_a = opts.getArrayKey) === null || _a === void 0 ? void 0 : _a.call(opts, a, path), true);
            if (indexMap.length !== a.length || indexMap.some((o, n) => o !== n)) {
                patches.push({ op: 'resortArray', path, indexMap });
            }
            indexMap.forEach((oldIdx, newIdx) => {
                const subPath = (0, path_1.pushPath)(path, newIdx);
                // 不需要复用的话就暴力替换
                if (oldIdx === -1)
                    patches.push({ op: createOp, path: subPath, value: b[newIdx] });
                // 否则还需要递归比对一下
                else
                    queue.push({ a: a[oldIdx], b: b[newIdx], path: subPath });
            });
        }
    }
    return patches;
}
exports.default = diff;
